<template>
  <main v-if="project" class="detalhe-project-card">
    <section class="jogo-detalhe-card">
      <h2>{{ project.name }}</h2>

      <section class="jogo-topo-card">
        <iframe
          :src="`${project.trailer}`"
          :title="`Trailer ${project.name}`"
          loading="lazy"
          allow="autoplay; encrypted-media"
          allowfullscreen
        ></iframe>

        <div class="jogo-info-card">
          <p><strong>Gênero:</strong> {{ project.genre }}</p>
          <p><strong>Lançamento:</strong> {{ project.releaseDate }}</p>
          <p><strong>Descrição:</strong></p>
          <p>{{ project.description }}</p>
        </div>
      </section>

      <GaleriaLoop
        v-if="project.screenshots?.length"
        :imagens="project.screenshots"
      />

      <section class="playstore-area">
        <p class="playstore-texto">DISPONÍVEL NA PLAY STORE</p>
        <a
          :href="project.playstore"
          target="_blank"
          rel="noopener noreferrer"
          class="playstore-botao"
        >
          <img :src="playstoreIcon" />
        </a>
      </section>
      <RouterLink :to="`/${project.privacyPolicy}`" class="more-info">
        <div class="project-more-info">
          <span class="project-button">Leia nossa política de privacidade</span>
        </div>
      </RouterLink>
    </section>
  </main>

  <h1 v-else>Jogo não encontrado</h1>
</template>

<script setup>
import { computed } from "vue"
import { useRoute } from "vue-router"
import { projects } from "@/data/projects"
import GaleriaLoop from "@/components/GaleriaLoop.vue"
import playstoreIcon from "@/assets/images/social-icons/playstore.png"

const route = useRoute()

const project = computed(() =>
  projects.find(j => j.name === route.params.name)
)

const videoId = computed(() =>
  project.value?.trailer?.split("/").pop()
)
</script>

<style>
.detalhe-project-card {
    width: 100%;
    max-width: 1200px;
    margin: 120px auto 0 auto;
    display: flex;
    justify-content: center;
    gap: 20px;
    flex-wrap: wrap;
}

.jogo-detalhe-card {
    width: 540px;
    display: flex;
    flex-direction: column;
    background:
        linear-gradient(145deg, rgba(255, 255, 255, 0.04), rgba(0, 0, 0, 0.25)),
        var(--fundo-card);
    border: 2px solid var(--borda-card);
    border-radius: 14px;
    box-shadow:
        0 10px 24px var(--sombra-escura),
        inset 0 1px 0 rgba(255, 255, 255, 0.05);
    padding-bottom: 20px;
}

.jogo-detalhe-card h2 {
    padding: 10px;
    font-size: 22px;
    letter-spacing: 1px;
    text-align: center;
    color: var(--texto-titulo);
    background-color: var(--fundo-card);
    border-bottom: 2px solid var(--borda-card);
    border-radius: 10px 10px 0 0;
}

.jogo-topo-card {
    display: flex;
    justify-content: center;
    gap: 10px;
    margin: auto;
    padding: 4px;
    flex-wrap: wrap;
}

.jogo-topo-card iframe {
    width: 245px;
    aspect-ratio: 16 / 9;
    border-radius: 10px;
    border: none;
}

.jogo-info-card {
    max-width: 270px;
    text-align: justify;
}

.jogo-info-card strong {
    font-size: 15px;
}

.jogo-info-card p {
    font-size: 14px;
    margin-bottom: 4px;
}

.galeria {
    width: 100%;
    max-width: 520px;
    margin: auto;
    padding: 4px;
    display: flex;
    gap: 6px;
    overflow-x: auto;
    overflow-y: hidden;
    scroll-behavior: smooth;
}

.galeria::-webkit-scrollbar {
    display: none;
}

.galeria img {
    flex: 0 0 auto;
    height: 200px;
    object-fit: cover;
    border-radius: 12px;
    border: 2px solid var(--borda-card);
    background-color: var(--fundo-card);
}

.playstore-area {
    margin: 20px auto 0;
    text-align: center;
}

.playstore-texto {
    font-size: 12px;
    font-weight: bold;
    letter-spacing: 1px;
    color: var(--texto-suave);
}

.playstore-botao {
    display: flex;
    align-items: center;
    justify-content: center;
}

.playstore-botao img {
    height: 40px;
    margin: 10px;
    transition: transform 0.25s ease;
}

.playstore-botao:hover {
    transform: scale(1.08);
}
</style>
